export const isValidPhoneNumber = (phone) => {
  return /^\+[1-9]\d{8,}$/.test(String(phone || ""))
}

export const normalizePhoneNumberInput = (rawValue) => {
  const raw = String(rawValue ?? "")
  let val = raw.replace(/\s+/g, "")

  // Keep the behavior from EmployeeDetailsView: empty becomes "+".
  if (!val) {
    return "+"
  }

  if (!val.startsWith("+")) {
    val = "+" + val.replace(/\+/g, "")
  } else {
    // Ensure exactly one leading plus.
    val = "+" + val.slice(1).replace(/\+/g, "")
  }

  // Strip non-digits after the plus
  let digits = val.slice(1).replace(/\D/g, "")
  // Remove any leading zeros in the digits (block 0 as first char)
  digits = digits.replace(/^0+/, "")

  return "+" + digits
}

